<div class="modal fade" id="Dialog_ASF" tabindex="-1" #modalDialogEl>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header ">
        <h1 class="modal-title" id="Dialog_Title">Speichern und Unterbrechen</h1>
      </div>
      <div class="modal-body">
        <p id="Dialog_Loeschen_Message">Ihre Angaben werden gespeichert. Sie können den Antrag zu einem anderen Zeitpunkt fortsetzen. Ihre Eingaben gehen <b>nicht</b> verloren.</p>
      </div>
      <div class="modal-footer">
        <button
          id="Dialog_Nein_Button"
          type="button"
          class="ba-btn ba-btn-contrast"
          data-bs-dismiss='modal'>
          Nein, weiter bearbeiten
        </button>
        <button
          id="Dialog_Ja_Button"
          type="button"
          class="ba-btn ba-btn-primary"
          (click)="commitEvent.emit()"
          data-bs-dismiss='modal'>
          Ja, zur Startseite
        </button>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->
